// Testimonials with Parallax
import { motion, useScroll, useTransform } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const Testimonials = () => {
    const testimonials = [
        {
            id: 1,
            quote: "Architecture should speak of its time and place, but yearn for timelessness.",
            author: "Abhishek Tamakuwala",
            position: "Chief Architect"
        },
        {
            id: 2,
            quote: "None of this would have been possible without the person who supported me throughout. Thank you Ar. Abhishek Tamakuwala.",
            author: "Ms. Aaliyah Pirzada",
            position: "Vesu"
        },
        {
            id: 3,
            quote: "Ar. Abhishek Tamakuwala understands the client & their requirement very well & execute the design accordingly.",
            author: "Mr. Dharmesh Patel",
            position: "Kamrej"
        },
        {
            id: 4,
            quote: "Ar. Abhishek Tamakuwala has a good knowledge of completing a lavish bungalow within the minimum set budget.",
            author: "Mr. Manish Patel",
            position: "Jokha"
        }
    ];

    return (
        <div
            className="section testimonials-section"
            style={{
                padding: '0',
                background: '#ffffff',
                margin: '10px 0',
            }}
        >
            <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '0 20px' }}>
                <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={30}
                    slidesPerView={1}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                >
                    {testimonials.map((testimonial) => (
                        <SwiperSlide key={testimonial.id}>
                            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                <h3 style={{
                                    fontSize: '1.2rem',
                                    lineHeight: 1.6,
                                    fontWeight: 'normal',
                                    fontFamily: 'PT Serif, serif',
                                    marginBottom: '20px',
                                    color: '#333'
                                }}>
                                    "{testimonial.quote}"
                                </h3>
                                <div>
                                    <h4 style={{ fontSize: '0.9rem', marginBottom: '5px', fontWeight: 500, color: '#333' }}>
                                        {testimonial.author}
                                    </h4>
                                    <small style={{ color: '#666', fontSize: '0.8rem' }}>{testimonial.position}</small>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};
export default Testimonials;